module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMnB4IiBoZWlnaHQ9IjMycHgiPjxwYXRoIGQ9Ik0gMTYgMyBDIDguOCAzIDMgOC44IDMgMTYgQyAzIDIzLjIgOC44IDI5IDE2IDI5IEMgMjMuMiAyOSAyOSAyMy4yIDI5IDE2IEMgMjkgOC44IDIzLjIgMyAxNiAzIHogTSAxNiA1IEMgMjIuMSA1IDI3IDkuOSAyNyAxNiBDIDI3IDIyLjEgMjIuMSAyNyAxNiAyNyBDIDEwLjIzNzcyNyAyNyA1LjU1MjYwNDkgMjIuNjI2MDQgNS4wNTA3ODEyIDE3IEwgMTMgMTcgTCAxMyAxOSBMIDE5IDE5IEwgMTkgMTMgTCAxMyAxMyBMIDEzIDE1IEwgNS4wNTA3ODEyIDE1IEMgNS41NTI2MDQ5IDkuMzczOTU5NSAxMC4yMzc3MjcgNSAxNiA1IHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons8-uber.svg
// module id = dMWW
// module chunks = 4